export default __webpack_public_path__ + "static/media/domo-poll.f5e99d8b.svg";